import {
  Box,
  BoxProps,
  Flex,
  FlexProps,
  chakra,
  Heading,
  HeadingProps,
} from "@chakra-ui/react";

import React from "react";
import { OverlayImage } from "../../components";

export interface FormWrapperProps {
  formElement: React.ReactNode;
  footer?: React.ReactNode;
  formTitle: string;
  withImage?: boolean;
  image?: string;
  socialAuthProviders?: SocialAuthProvider[];
  variant?: string;
}

export interface FormWrapperExtraProps {
  formWrapperBoxProps?: FlexProps;
  formContainerProps?: BoxProps;
  formHeaderProps?: HeadingProps;
  formImageProps?: BoxProps;
}
export interface SocialAuthProvider {
  providerName: string;
  providerSvg: string;
}

function BigFormWrapper({
  formElement,
  formTitle,
  withImage = true,
  image,
  socialAuthProviders,
  formWrapperBoxProps,
  formContainerProps,
  formHeaderProps,
  formImageProps,
  footer,
}: FormWrapperProps & FormWrapperExtraProps) {
  const showImage = withImage && image;
  const elementToRender = React.isValidElement<{
    socialAuthProviders?: SocialAuthProvider[];
  }>(formElement)
    ? React.cloneElement(formElement, { socialAuthProviders })
    : formElement;
  return (
    <>
      <Flex
        boxShadow="lg"
        maxW="70rem"
        mx="auto"
        borderRadius="lg"
        overflow="hidden"
        display={{
          base: "none",
          md: "flex",
          xl: "flex",
        }}
        {...formWrapperBoxProps}
      >
        {showImage && (
          <Box flex={1}>
            <OverlayImage
              overlayProps={formImageProps}
              src={image}
              w="full"
              minH="30rem"
              h="full"
              objectPosition="center"
              objectFit="cover"
              alt={formTitle}
            />
          </Box>
        )}

        <Box flex={1} px="3rem" py="1rem" {...formContainerProps}>
          <Heading as="h3" size="xl" {...formHeaderProps}>
            {formTitle}
          </Heading>
          <Box>{elementToRender}</Box>
        </Box>
      </Flex>
      <Flex
        align="center"
        justify="center"
        // p={4}
        mt={20}
        display={{
          base: "flex",
          md: "none",
        }}
      >
        <Box
          position="relative"
          w={{ base: "90%", sm: "380px" }}
          bg="#F0F0F0"
          rounded="lg"
          overflow="hidden"
          p={0}
        >
          <chakra.div
            position="absolute"
            top="50%"
            left="-1rem"
            w="2rem"
            h="2rem"
            bg="white"
            rounded="full"
            transform="translateY(-50%)"
          />
          <chakra.div
            position="absolute"
            top="50%"
            right="-1rem"
            w="2rem"
            h="2rem"
            bg="white"
            rounded="full"
            transform="translateY(-50%)"
          />
          <Box p={{ base: 6, sm: 8 }} textAlign="center">
            <Box fontSize="24px" fontWeight="600" mb={6} lineHeight={"100%"}>
              {formTitle}
            </Box>
            {elementToRender}
          </Box>
          <Box>{footer}</Box>
        </Box>
      </Flex>
    </>
  );
}

export default BigFormWrapper;
